import { render, staticRenderFns } from "./inviteOfferLetterDialog.vue?vue&type=template&id=3bca0748&scoped=true"
import script from "./inviteOfferLetterDialog.vue?vue&type=script&lang=js"
export * from "./inviteOfferLetterDialog.vue?vue&type=script&lang=js"
import style0 from "./inviteOfferLetterDialog.vue?vue&type=style&index=0&id=3bca0748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bca0748",
  null
  
)

export default component.exports